export { Label } from '@theme-ui/components';
export type { LabelProps } from '@theme-ui/components';
